<template>
  <router-view />
</template>

<script>
  import i18n from 'core/i18n';
  import store from 'core/store';
  import router from 'core/router';

  export default {
    i18n,
    store,
    router,
  };
</script>

<style lang="scss" src="./styles/main.scss">



// WEBPACK FOOTER //
// src/App.vue